'use client'

import React, { useEffect, useMemo, useState } from 'react'
import classNames from 'classnames/bind'
import { Banknote, HandCoins, Landmark, ListOrdered, Receipt } from 'lucide-react'

import { LoadingSpinner } from '@fsg/gui-bits'
import { useRequestCallback } from '@fsg/next-auth'

import { MarketingSummaryKPI } from '@app/types'

import { ENDPOINTS } from '../../../lib/constants'
import { KPICard } from '../KPICard'
import moduleStyles from './MarketingSummaryKPIs.module.scss'

const cx = classNames.bind(moduleStyles)

type Props = {
  count: number
  query: string
}

// hide cents
const formatDollars = (value: number) => {
  return (value || 0).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  })
}

export function MarketingSummaryKPIs({ count, query }: Props) {
  const [kpis, setKpis] = useState<MarketingSummaryKPI>({
    count: count,
    estimatedDollars: 0,
    probabilityDollars: 0,
    quotedDollars: 0,
    actualOrderValue: 0,
  })
  const [loading, setLoading] = useState(false)
  const { request } = useRequestCallback()

  useEffect(() => {
    ;(async () => {
      setLoading(true)
      if (query) {
        if (query.includes('type:null()')) {
          query = query.replace('type:null()', 'type:in( )')
        }

        const response = await request<MarketingSummaryKPI>({ path: `${ENDPOINTS.REPORTS.MARKETING_SUMMARY}?filter=${encodeURIComponent(query)}` })
        setKpis(response)
      }
      setLoading(false)
    })()
  }, [query])

  return (
    <>
      <div className={cx('card-row')}>
        <KPICard label="Count" primary={count} icon={<ListOrdered className={cx('kpi-icon')} />} />
        <KPICard
          label="Estimated Dollars"
          primary={loading ? <LoadingSpinner /> : formatDollars(kpis.estimatedDollars)}
          icon={<Banknote className={cx('kpi-icon')} />}
        />
        <KPICard
          label="Probability Dollars"
          primary={loading ? <LoadingSpinner /> : formatDollars(kpis.probabilityDollars)}
          icon={<HandCoins className={cx('kpi-icon')} />}
        />
        <KPICard
          label="Quoted Dollars"
          primary={loading ? <LoadingSpinner /> : formatDollars(kpis.quotedDollars)}
          icon={<Receipt className={cx('kpi-icon')} />}
        />
        {/* <KPICard label="Total Actual Order Value" primary={formatDollars(kpis.actualOrderValue)} icon={<Landmark className={cx('kpi-icon')} />} /> */}
      </div>
    </>
  )
}
